var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import PropTypes from 'prop-types';
import React, { Component } from 'react';

import Grid from '../../components/Grid';
import Clickable from '../../components/Clickable';
import Text from '../../components/TextWithAudio';

import { TEMPLATE_TYPE } from '../../constants';

var AnswerText = function (_Component) {
  _inherits(AnswerText, _Component);

  function AnswerText() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, AnswerText);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AnswerText.__proto__ || Object.getPrototypeOf(AnswerText)).call.apply(_ref, [this].concat(args))), _this), _this.getClozeAnswersById = function () {
      var textElements = _this.props.textElements;
      var getInputId = _this.context.getInputId;

      return textElements.filter(function (textElement) {
        return JSON.parse(textElement.config).id === getInputId;
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(AnswerText, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          type = _props.type,
          textElements = _props.textElements,
          multipleChoice = _props.multipleChoice;

      var answers = textElements;
      if (type === TEMPLATE_TYPE.ANSWER_CLOZE) {
        answers = this.getClozeAnswersById();
      }
      return React.createElement(
        Grid,
        { theme: multipleChoice && 'singleRow' },
        answers.map(function (textElement) {
          var text = textElement.text,
              id = textElement.id,
              config = textElement.config;

          var elementId = id;
          var elementType = '';
          if (type === TEMPLATE_TYPE.ANSWER_CLOZE) {
            var element = JSON.parse(config).id + ':' + JSON.parse(config).sort;
            elementId = element;
            elementType = JSON.parse(config).type;
          }
          return React.createElement(
            Clickable,
            { key: textElement.id, type: type, element: { id: elementId, text: text, type: elementType }, multipleChoice: multipleChoice },
            React.createElement(Text, { text: text, id: elementId, audioSource: textElement.audioSource, theme: 'taskAnswer' })
          );
        })
      );
    }
  }]);

  return AnswerText;
}(Component);

export default AnswerText;


AnswerText.propTypes = process.env.NODE_ENV !== "production" ? {
  type: PropTypes.string,
  textElements: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    text: PropTypes.string
  })),
  multipleChoice: PropTypes.bool
} : {};

AnswerText.defaultProps = {
  type: '',
  textElements: [],
  multipleChoice: false
};

AnswerText.contextTypes = {
  getInputId: PropTypes.string
};